import { imageUrl } from '@helpers/image';
import { useScrollHandler } from '@hooks/useScrollHandler';
import React, { useCallback, useEffect, useState } from 'react';
import DesktopNavigation from './DesktopNavigation/DesktopNavigation';
import S from './Header.styles';
import MobileHeader from './MobileHeader/MobileHeader';
import MobileNavigation from './MobileNavigation/MobileNavigation';
import SearchOverlay from './SearchOverlay/SearchOverlay';
import TopLinks from './TopLinks/TopLinks';
const SCROLL_THRESHOLD = 50;
const Header = ({ alwaysActive, logoAltText, logoColor, logoGreyscale, navigation, reduced = false, scrollThreshold = SCROLL_THRESHOLD, search, topLinks, }) => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isNavigationActive, setIsNavigationActive] = useState(false);
    const [isSearchActive, setIsSearchActive] = useState(false);
    useScrollHandler(() => setIsScrolled(window.scrollY > scrollThreshold), true);
    useEffect(() => {
        if (isNavigationActive) {
            setIsSearchActive(false);
        }
    }, [isNavigationActive]);
    useEffect(() => {
        if (isSearchActive) {
            setIsNavigationActive(false);
        }
    }, [isSearchActive]);
    const onSearchToggle = useCallback(() => {
        setIsSearchActive(!isSearchActive);
    }, [isSearchActive]);
    const onNavigationToggle = useCallback(() => {
        setIsNavigationActive(!isNavigationActive);
    }, [isNavigationActive]);
    return (React.createElement(S.Root, { "data-active": alwaysActive || isScrolled || isNavigationActive || isSearchActive, "data-reduced": reduced },
        React.createElement(S.GlobalStyles, { reduced: reduced }),
        React.createElement(S.Container, null,
            React.createElement(TopLinks, { items: topLinks ?? [] }),
            React.createElement(S.Inner, null,
                React.createElement(S.LogoWrapper, { href: "/", "aria-label": "Home" },
                    React.createElement(S.Logo, { alt: logoAltText, loading: "eager", src: imageUrl({ src: logoColor ?? logoGreyscale }, {}), "aria-hidden": true })),
                React.createElement(DesktopNavigation, { items: navigation, reduced: reduced, onSearchToggle: onSearchToggle, isSearchActive: isSearchActive }),
                React.createElement(MobileHeader, { isActive: isNavigationActive, isSearchActive: isSearchActive, reduced: reduced, onNavigationToggle: onNavigationToggle, onSearchToggle: onSearchToggle }))),
        !reduced && (React.createElement(MobileNavigation, { isActive: isNavigationActive, items: navigation, otherItems: topLinks })),
        isSearchActive && (React.createElement(SearchOverlay, { ...search, isActive: isSearchActive, onSearchToggle: onSearchToggle }))));
};
export default Header;
